import { QueryKey, useMutation, useQueryClient } from 'react-query';
import { MutationDTO } from '../shared/models/API';

const useDeleteMutation = <Params, RequestBody, Response>(
	queryKey: QueryKey,
	mutation: MutationDTO<Params, RequestBody, Response>,
	invalidateQueries?: QueryKey
) => {
	const queryClient = useQueryClient();

	const result = useMutation(mutation, {
		onMutate: async (idToRemove) => {
			await queryClient.cancelQueries(queryKey);
			const previousEntities = queryClient.getQueryData(queryKey);

			queryClient.setQueryData<Response>(queryKey, (old: any) => {
				return {
					...old,
					items: (old?.items || []).filter(
						(entity: any) => entity.id !== idToRemove
					),
				};
			});

			return { previousEntities };
		},
		onError: (err, idToRemove, context) => {
			queryClient.setQueryData(queryKey, context?.previousEntities);
		},
		onSettled: () => {
			queryClient.invalidateQueries(queryKey);
			if (invalidateQueries) {
				queryClient.invalidateQueries(invalidateQueries);
			}
		},
	});

	return result;
};

export default useDeleteMutation;
